import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/components/auth-provider";
import { useEffect } from "react";
import Header from "@/components/header";

export default function TenantLayout() {
  const { status, user } = useAuth();
  const navigate = useNavigate();

  // Redirect if not authenticated
  useEffect(() => {
    if (status === "unauthenticated") {
      navigate("/auth/signin", { replace: true });
    }
  }, [status, navigate]);

  // Redirect if not a tenant (but allow admin/super-admin)
  // Note: user.role comes from Firebase Custom Claims (secure, server-side only)
  useEffect(() => {
    if (status === "authenticated" && user) {
      console.log("Tenant layout - user role (from custom claims):", user.role);

      const userRole = user.role;

      // Allow tenants, admins, and super-admins
      if (
        userRole !== "tenant" &&
        userRole !== "admin" &&
        userRole !== "super-admin"
      ) {
        console.log("User role not allowed for tenant portal:", userRole);
        if (userRole === "landlord") {
          console.log("Redirecting landlord to landlord portal");
          navigate("/landlord", { replace: true });
        } else {
          console.log("No appropriate role found, redirecting to home");
          navigate("/", { replace: true });
        }
      } else {
        console.log("Access granted to tenant portal for role:", userRole);
      }
    }
  }, [status, user, navigate]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto py-6 px-4">
        <Outlet />
      </main>
    </div>
  );
}
